import { Button, Box } from '@mui/material'
import React from 'react'

interface FormSubmitButtonProps {
  isEditMode: boolean
  isSubmitting: boolean
  onCancel?: () => void
}

/**
 * FormSubmitButton - Component for form submission button
 *
 * Handles the submit button with appropriate text and disabled state.
 */
export default function FormSubmitButton({
  isEditMode,
  isSubmitting,
  onCancel
}: FormSubmitButtonProps) {
  const getButtonText = () => {
    if (isSubmitting) {
      return isEditMode ? 'Saving...' : 'Creating...'
    }
    return isEditMode ? 'Save Changes' : 'Create Desk'
  }

  return (
    <Box sx={{ mt: 4, mb: 2 }}>
      <Button
        type='submit'
        fullWidth
        variant='contained'
        sx={{
          py: 1.5,
          borderRadius: 2,
          background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 24px rgba(102, 126, 234, 0.6)'
          },
          '&:disabled': {
            background: 'rgba(0,0,0,0.12)',
            transform: 'none',
            boxShadow: 'none'
          }
        }}
        disabled={isSubmitting}
        color='primary'
        id={isEditMode ? 'savedesk' : 'createdesk'}
      >
        {getButtonText()}
      </Button>

      {onCancel && (
        <Button
          fullWidth
          variant='outlined'
          onClick={onCancel}
          sx={{
            mt: 2,
            py: 1.5,
            borderRadius: 2,
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }
          }}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
      )}
    </Box>
  )
}
